export function getAlignmentStyles(alignment: string | undefined): { justifyContent: string; alignItems: string } {
    switch (alignment) {
        case 'center':
            return { justifyContent: 'center', alignItems: 'center' };
        case 'centerRight':
            return { justifyContent: 'flex-end', alignItems: 'center' };
        case 'centerLeft':
            return { justifyContent: 'flex-start', alignItems: 'center' };
        case 'topCenter':
            return { justifyContent: 'center', alignItems: 'flex-start' };
        case 'topLeft':
            return { justifyContent: 'flex-start', alignItems: 'flex-start' };
        case 'topRight':
            return { justifyContent: 'flex-end', alignItems: 'flex-start' };
        case 'bottomCenter':
            return { justifyContent: 'center', alignItems: 'flex-end' };
        case 'bottomLeft':
            return { justifyContent: 'flex-start', alignItems: 'flex-end' };
        case 'bottomRight':
            return { justifyContent: 'flex-end', alignItems: 'flex-end' };
        default:
            return { justifyContent: 'center', alignItems: 'center' };
    }
}